export default __webpack_public_path__ + "c288f0bec0ff4dc7d33ae4448e7e1a87.png";